import * as React from 'react';
import { ExamsInProcessingContainer } from '../../containers';

const ExamsInProcessingPage = () => <ExamsInProcessingContainer />;

export default ExamsInProcessingPage;
